import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';

import EmployeesAutocomplete from 'containers/EmployeesAutocomplete';
import Select from 'components/Select';
import DateTimeInput from 'components/DateTimeInput';

import RightColumnBody from 'styled/Page/RightColumnBody';
import Label from 'styled/Label';
import Input from 'styled/Input';
import PrimaryButton from 'styled/Buttons/PrimaryButton';

const START_LOG_TIME = '2019-02-07';

const EVENTS = [
  { label: 'Все', value: 'all' },
  { label: 'Создание', value: 'create' },
  { label: 'Обновление', value: 'update' },
  { label: 'Удаление', value: 'destroy' },
];

const OBJECT_TYPES = [
  { label: 'Все', value: 'all' },
  { label: 'Посты', value: 'Post' },
  { label: 'Снузы', value: 'ItemSnooze' },
  { label: 'Обложка', value: 'Media::MediaFile' },
];

const DEFAULT_VALUE = {
  label: 'Все',
  value: 'all',
};

function getDateTime(date, time) {
  if (date && time) return `${date}T${time}`;
  if (!time && date) return date;

  return '';
}

class AuditForm extends React.PureComponent {
  state = {
    startDate: '',
    startTime: '',
    endDate: '',
    endTime: '',
    itemId: '',
    itemType: OBJECT_TYPES[0].value,
    event: EVENTS[0].value,
    employee: DEFAULT_VALUE,
  }

  get isDateValid() {
    if (!this.state.endDate || !this.state.startDate) return true;
    if (this.state.startDate > this.state.endDate
      || (this.state.startDate === this.state.endDate && this.state.startTime > this.state.endTime)
    ) return false;

    return true;
  }

  handleValueChange = ({ target }) => {
    this.setState({ [target.id]: target.value });
  }

  handleEmployeeChange = (employee) => {
    this.setState({ employee });
  }

  handleFindClick = () => {
    if (!this.isDateValid) {
      Alert.error('Начальная дата не может быть больше конечной');
      return;
    }

    this.setState(prevState => ({
      startTime: prevState.startDate && !prevState.startTime ? '00:00:00' : prevState.startTime,
      endTime: prevState.endDate && !prevState.endTime ? '23:59' : prevState.endTime,
    }), () => {
      this.props.onSubmit({
        startDate: getDateTime(this.state.startDate, this.state.startTime),
        endDate: getDateTime(this.state.endDate, this.state.endTime),
        itemId: this.state.itemId,
        itemType: this.state.itemType,
        event: this.state.event,
        employee: this.state.employee,
      });
    });
  }

  render() {
    return (
      <React.Fragment>
        <RightColumnBody>
          <Label htmlFor="startDate">С</Label>

          <DateTimeInput
            onChange={this.handleValueChange}
            dateId="startDate"
            timeId="startTime"
            time={this.state.startTime}
            date={this.state.startDate}
            min={START_LOG_TIME}
          />

          <Label style={{ marginTop: '24px' }} htmlFor="endDate">До</Label>

          <DateTimeInput
            onChange={this.handleValueChange}
            dateId="endDate"
            timeId="endTime"
            time={this.state.endTime}
            date={this.state.endDate}
            min={this.state.startDate || START_LOG_TIME}
          />

          <Label style={{ marginTop: '24px' }} htmlFor="itemId">ID объекта</Label>

          <Input
            id="itemId"
            type="text"
            placeholder="Введите id"
            value={this.state.itemId}
            onChange={this.handleValueChange}
          />

          <Label style={{ marginTop: '24px' }} htmlFor="itemType">Тип объекта</Label>

          <Select
            id="itemType"
            type="text"
            value={this.state.itemType}
            onChange={this.handleValueChange}
          >
            {OBJECT_TYPES.map(type => (
              <option key={type.value} value={type.value}>{type.label}</option>
            ))}
          </Select>

          <Label style={{ marginTop: '24px' }} htmlFor="event">Действие</Label>

          <Select
            id="event"
            type="text"
            onChange={this.handleValueChange}
            value={this.state.event}
          >
            {EVENTS.map(event => (
              <option key={event.value} value={event.value}>{event.label}</option>
            ))}
          </Select>

          <Label style={{ marginTop: '24px' }} htmlFor="employee">Сотрудник</Label>

          <EmployeesAutocomplete
            disabled={this.props.loading}
            onChange={this.handleEmployeeChange}
            employee={this.state.employee}
          />

          <PrimaryButton
            type="button"
            onClick={this.handleFindClick}
            aria-label="Найти изменения"
            disabled={this.props.loading}
            style={{ marginTop: '24px', padding: '10px' }}
          >
            Найти
          </PrimaryButton>
        </RightColumnBody>
      </React.Fragment>
    );
  }
}

AuditForm.propTypes = {
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
};

AuditForm.defaultProps = {
  onSubmit: () => {},
  loading: false,
};

export default AuditForm;
